import React from "react";

export const docMenu = [
  {
    name: "Introduction",
    dropDownItems: [
      {
        name: "Introduction",
        routerPath: "/uzmart-single-documentation/introduction",
      },
      {
        name: "Installation Videos",
        routerPath: "/uzmart-single-documentation/installation-video",
      },
      {
        name: "Server requirements",
        routerPath: "/uzmart-single-documentation/recommendations",
      },
    ],
  },
  {
    name: "Backend Api",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/uzmart-single-documentation/server",
      },
      {
        name: "Installation",
        routerPath: "/uzmart-single-documentation/mandatory-setup-backend",
      },
      {
        name: "Payment installation",
        routerPath: "/uzmart-single-documentation/payment-installation",
      },
      {
        name: "Image settings",
        routerPath: "/uzmart-single-documentation/image-settings",
      },
      {
        name: "Troubleshooting",
        routerPath: "/uzmart-single-documentation/troubleshooting-backend",
      },
    ],
  },
  {
    name: "Admin Panel",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/uzmart-single-documentation/admin",
      },
      {
        name: "Installation",
        routerPath: "/uzmart-single-documentation/install-on-server",
      },
      {
        name: "Troubleshooting",
        routerPath: "/uzmart-single-documentation/troubleshooting-admin",
      },
    ],
  },
  {
    name: "Customer Website",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/uzmart-single-documentation/front",
      },
      {
        name: "Installation",
        routerPath: "/uzmart-single-documentation/mandatory-setup-web",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Customer App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/uzmart-single-documentation/mobile-app",
      },
      {
        name: "Installation",
        routerPath: "/uzmart-single-documentation/mandatory-setup-customer",
      },
      {
        name: "Customization",
        routerPath: "/uzmart-single-documentation/customization-customer",
      },
      {
        name: "App build & release",
        routerPath: "/uzmart-single-documentation/customer-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Vendor and Driver App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/uzmart-single-documentation/vendor-app",
      },
      {
        name: "Installation",
        routerPath: "/uzmart-single-documentation/mandatory-setup-vendor",
      },
      {
        name: "Customization",
        routerPath: "/uzmart-single-documentation/customization-vendor",
      },
      {
        name: "App build & release",
        routerPath: "/uzmart-single-documentation/vendor-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  // {
  //   name: "Driver App",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/uzmart-single-documentation/driver-app",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/uzmart-single-documentation/mandatory-setup-deliveryboy",
  //     },
  //     {
  //       name: "Customization",
  //       routerPath: "/uzmart-single-documentation/customization-deliveryboy",
  //     },
  //     {
  //       name: "App build & release",
  //       routerPath: "/uzmart-single-documentation/deliveryboy-app-build-release",
  //     },
  //     // {
  //     //   name: "Troubleshooting",
  //     //   routerPath: "/",
  //     // },
  //   ],
  // },
  {
    name: "Pos App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/uzmart-single-documentation/pos-app",
      },
      {
        name: "Installation",
        routerPath: "/uzmart-single-documentation/mandatory-setup-pos",
      },
      {
        name: "Customization",
        routerPath: "/uzmart-single-documentation/customization-pos",
      },
      {
        name: "App build & release",
        routerPath: "/uzmart-single-documentation/pos-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Firebase setup",
    routerPath: "/uzmart-single-documentation/firebase",
  },
  {
    name: "Update",
    routerPath: "/uzmart-single-documentation/update",
  },
];

export const payments = [
  {
    icon: (
        <img
            src={"./assets/img/root/paypal.png"}
            alt="img"
            width="80"
            height="80"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/stripe.png"}
            alt="img"
            width="80"
            height="80"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/razorpay.png"}
            alt="img"
            width="80"
            height="80"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/paystack.jpeg"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/pay-tabs.jpg"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/flw.png"}
            alt="img"
            width="110"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/mercado-pago.jpg"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/moyasar.png"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/mollie.png"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/maksekeskus.png"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
];

